<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi">O<span class="smallcaps">THER TITLES IN THE CAMPAIGN CHRONICLES SERIES</span></p>
<p class="dedi1">Armada 1588<br/> <i>John Barratt</i></p>
<p class="dedi1">Napoleon’s Polish Gamble<br/> Eylau and Friedland 1807<br/> <i>Christopher Summerville</i></p>
<p class="dedi1">Passchendaele<br/> The Hollow Victory<br/> <i>Martin Marix Evans</i></p>
<p class="dedi1">Attack on the Somme<br/> Haig’s Offensive 1916<br/> <i>Martin Pegler</i></p>
<p class="dedi1">Salerno 1943<br/> The Invasion of Italy<br/> <i>Angus Konstam</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?57ab0812